import type { Ownership } from './types';

type AvatarShape = 'round' | 'square';

const getAvatarShape = (claimed: boolean, ownership: Ownership, hasUploadedLogo: boolean): AvatarShape => {
  if (!claimed) return 'square';
  if (hasUploadedLogo) return 'square';

  return ownership === 'vendor' ? 'square' : 'round';
};

export { getAvatarShape };
export type { AvatarShape };
